import {
  Description,
  Dialog,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react'
import { resendSignUpCode } from 'aws-amplify/auth'
import { Field, Form, Formik } from 'formik'
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Button from '../components/Button'

export const ResendConfirmationEmail = () => {
  const [hasError, setHasError] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const sendConfirmationEmail = async ({ email }: { email: string }) => {
    setLoading(true)
    try {
      await resendSignUpCode({ username: email })
      navigate('/login')
    } catch (e: any) {
      setErrorMessage(e.message)
      setHasError(true)
      setLoading(false)
    }
  }

  return (
    <>
      <Dialog
        open={hasError}
        onClose={() => setHasError(false)}
        className="relative z-50"
      >
        <div className="fixed inset-0 bg-black/30" />
        <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
          <DialogPanel className="mx-auto rounded-lg p-10 bg-primary-50 w-2/6">
            <DialogTitle>
              Error while sending your confirmation email
            </DialogTitle>
            <Description className="py-4">{errorMessage}</Description>

            <button
              className="ircam-button button button-regular button-dark block mx-auto px-4 py-2"
              type="button"
              onClick={() => setHasError(false)}
            >
              <div className="button-label">OK</div>
            </button>
          </DialogPanel>
        </div>
      </Dialog>
      <div className="w-4/6 mx-auto mt-28">
        <h1 className="text-4xl text-center my-8 font-light">
          Activation email
        </h1>
        <Formik
          initialValues={{
            email: '',
          }}
          onSubmit={sendConfirmationEmail}
        >
          <div className="w-full my-4">
            <Form>
              <div className="my-8">
                <label htmlFor="email" className="text-sm">
                  Email address
                  <Field
                    type="text"
                    name="email"
                    id="email"
                    className="w-full ircam-input"
                  />
                </label>
              </div>
              <div className="my-2">
                <button
                  type="submit"
                  className="w-full button button-large button-dark py-2 px-4"
                >
                  <div className="button button-label">
                    Resend me the activation link
                  </div>
                </button>
              </div>
              <div className="my-2">
                <Button
                  as={Link}
                  to="/login"
                  label="Cancel"
                  dark={false}
                  className="w-full my-8 py-2 text-center"
                  disabled={loading}
                />
              </div>
            </Form>
          </div>
        </Formik>
      </div>
    </>
  )
}
